/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  if (window.disableAutoTargetLinks) {
    return
  }

  // Open external links and PDFs in new window
  $('a[href], area[href]')
    .filter(function() {
      const href = $(this).attr('href')
      const isExternal = href.indexOf(window.location.hostname) == -1 && href.match(/^https?/i)
      const isPDF = href.match(/\.pdf$/i)

      return href && !this.target && (isExternal || isPDF)
    })
    .attr('target', '_blank')
    .attr('rel', 'noopener noreferrer')
}
